import { TFunction } from 'i18next'

import { LanguageResources } from '@/@types/i18next'
import { Gender } from '../models/person'

export function translateGender(
  t: TFunction<[LanguageResources]>,
  gender: Gender,
): string {
  switch (gender) {
    case Gender.MALE:
      return t('common:enums.gender.male')
    case Gender.FEMALE:
      return t('common:enums.gender.female')
    case Gender.OTHER:
      return t('common:enums.gender.other')
    default:
      return t('common:enums.gender.other')
  }
}
